module.exports = __webpack_public_path__ + "fdcac74bff054ccc050d5b6def925081.gif";